import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/components/legal/legal-page";
import { REFUNDS } from "@/lib/legal";

export const Route = createFileRoute("/refunds")({
  component: () => <LegalPage doc={REFUNDS} />,
});
